import React from 'react';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

export interface ActivityLinkProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  className?: string;
}

export const ActivityLink: React.FC<ActivityLinkProps> = ({
  children,
  href,
  onClick,
  icon,
  className,
}) => {
  const sharedClassName = cn(
    'inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-800',
    className,
  );

  const content = (
    <>
      {icon && <span className="flex-shrink-0">{icon}</span>}
      {children}
    </>
  );

  if (href) {
    return (
      <Link to={href} onClick={onClick} className={sharedClassName}>
        {content}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick} className={sharedClassName}>
      {content}
    </button>
  );
};
